<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col xl="6" md="6" sm="12">
              <span class="f-g">
                <h1 class="m-0 f-g">Categoria: {{ descricao }}</h1>
              </span>
            </b-col>
            <b-col xl="6" md="6" sm="12">
              <div>
                <b-button
                  variant="success"
                  class="my-2 my-sm-0 w100 mr5"
                  @click="save"
                >Confirmar</b-button>
                <b-button
                  variant="danger"
                  class="my-2 my-sm-0 mr-sm-2 w100"
                  type="submit"
                  @click="goBack"
                >
                  <i class="fa fa-arrow-left"></i>
                  Voltar
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col xl="6" lg="6" md="12" sm="12">
        <b-card header="Imagem Atual" class="mt-2">
          <center>
            <img
              v-if="imageSource != null && imageSource != '' && imageSource != 'null'"
              :src="imageSource"
              alt="Imagem da Promoção"
              style="width:500px;"
            />
            <span v-else>Não há imagem vinculada</span>
          </center>
        </b-card>
      </b-col>
      <b-col xl="6" lg="6" md="12" sm="12">
        <b-card header="Editar Imagem" class="mb-0 mt-2">
          <picture-input
            ref="pictureInput"
            width="600"
            height="300"
            margin="16"
            accept="image/jpeg, image/png"
            size="10"
            button-class="btn"
            :zIndex="1"
            :custom-strings="{
            upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
            drag: 'Arraste uma imagem <br> (ou clique aqui)',
            change: 'Mudar foto'
          }"
            @change="onChange"
          ></picture-input>
        </b-card>
      </b-col>
      <b-col cols="12">
        <b-card class="mb-3 w-100 mt-2 mb-2">
          <template slot="header">
            <span style="vertical-align:center;">Vínculos</span>
            <b-button
              class="float-right"
              variant="outline-success"
              @click="openModal(1)"
            >Vincular novo setor</b-button>
            <b-button
              class="float-right mr-3"
              variant="outline-success"
              @click="openModal(2)"
            >Vincular novo grupo</b-button>
          </template>
          <b-table
            :items="vinculos"
            :fields="fields_vinculos"
            v-if="vinculos.length > 0"
            bordered
            striped
            hover
            responsive="sm"
            @row-clicked="deletar"
          ></b-table>
          <center v-else>
            <span>Não foi encontrado nenhum vínculo</span>
          </center>
        </b-card>
      </b-col>
      <b-col cols="12"></b-col>
    </b-row>
    <b-modal ref="addSetor" centered hide-footer style="z-index:100000000000000">
      <template slot="modal-title">
        <div>Vincular novo setor</div>
      </template>
      <b-row>
        <b-col cols="12">
          <b-form-group>
            <b-input-group size="sm" prepend="Filtro">
              <b-form-input v-model="filterSetor" type="search" placeholder="Escreva para filtrar"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filterSetor" @click="filterSetor = ''">Limpar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-pagination
            v-model="currentPageSetor"
            :total-rows="totalRowsSetor"
            :per-page="perPageSetor"
            align="fill"
            size="sm"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-table
        :items="setores"
        :fields="fields_setores"
        :filter="filterSetor"
        :filterIncludedFields="filterOnSetor"
        :current-page="currentPageSetor"
        :per-page="perPageSetor"
        :selectable="true"
        select-mode="single"
        @row-selected="selecionaSetor"
        v-if="setores.length > 0"
        bordered
        striped
        hover
        responsive="sm"
        @filtered="onFilteredSetor"
      ></b-table>
      <b-button variant="success" class="mw" @click="vincularSetor">Confirmar</b-button>
    </b-modal>
    <b-modal ref="addGrupo" centered hide-footer style="z-index:100000000000000">
      <template slot="modal-title">
        <div>Vincular novo grupo</div>
      </template>
      <b-row>
        <b-col cols="12">
          <b-form-group>
            <b-input-group size="sm" prepend="Filtro">
              <b-form-input v-model="filterGrupo" type="search" placeholder="Escreva para filtrar"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filterGrupo" @click="filterGrupo = ''">Limpar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-pagination
            v-model="currentPageGrupo"
            :total-rows="totalRowsGrupo"
            :per-page="perPageGrupo"
            align="fill"
            size="sm"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-table
        :items="grupos"
        :fields="fields_grupos"
        :filter="filterGrupo"
        :filterIncludedFields="filterOnGrupo"
        :current-page="currentPageGrupo"
        :per-page="perPageGrupo"
        :selectable="true"
        select-mode="single"
        @row-selected="selecionaGrupo"
        v-if="grupos.length > 0"
        @filtered="onFilteredGrupo"
        bordered
        striped
        hover
        responsive="sm"
      ></b-table>
      <b-button variant="success" class="mw" @click="vincularGrupo">Confirmar</b-button>
    </b-modal>
    <b-modal ref="deletarLinha" centered hide-footer style="z-index:100000000000000">
      <template slot="modal-title">
        <div>Opções</div>
      </template>
      <b-row>
        <b-col cols="12">
          <div class="centerModal" @click="excluir">
            <i class="fa fa-times fa-4x"></i>
            <span class="span-card">Excluir</span>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import PictureInput from "vue-picture-input";
import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "editarimagem",
  components: { PictureInput, Loading },
  data: function() {
    return {
      filterSetor: null,
      filterOnSetor: [],
      filterGrupo: null,
      filterOnGrupo: [],
      currentPageSetor: 1,
      perPageSetor: 5,
      totalRowsSetor: 1,
      currentPageGrupo: 1,
      perPageGrupo: 5,
      totalRowsGrupo: 1,
      isLoading: false,
      imageSource: null,
      saveBtn: false,
      descricao: null,
      vinculos: [],
      setorSelecionado: null,
      descricaoSetorSelecionado: null,
      grupoSelecionado: null,
      descricaoGrupoSelecionado: null,
      fields_vinculos: [
        { key: "tipodescricao", label: "Tipo" },
        { key: "interessedescricao", label: "Interesse" },
        { key: "codigovinculado", label: "Código Interno" }
      ],
      setores: [],
      fields_setores: [
        { key: "descricao", label: "Descrição" },
        { key: "qtdprodutos", label: "Quantidade" }
      ],
      grupos: [],
      fields_grupos: [
        { key: "descricao", label: "Descrição" },
        { key: "qtdprodutos", label: "Quantidade" }
      ],
      selecionado: 2,
      linhaSelecionada: null
    };
  },
  methods: {
    async excluir() {
      if (this.linhaSelecionada != null) {
        this.$refs.deletarLinha.hide();
        const options = {
          title: "Excluir vínculo",
          cancelLabel: "Cancelar",
          okLabel: "Sim"
        };
        await this.$dialogs
          .confirm("Confirma excluir este vinculo?", options)
          .then(async res => {
            await axios
              .delete(
                `${config.default.servidor}/gerencial/vinculo-interesse/${this.linhaSelecionada}`,
                {
                  headers: {
                    Authorization: "Basic c2E6QURNQUNDRVNZUw=="
                  }
                }
              )
              .then(async response => {
                if (response.status == 200) {
                  const options = { title: "Aviso", size: "sm" };
                  this.isLoading = true;
                  await this.receberVinculos();
                  this.isLoading = false;
                  this.$dialogs.alert("Vinculo excluído com sucesso!", options);
                }
              });
          });
      }
    },
    deletar(record) {
      if (record) {
        this.linhaSelecionada = record.id;
        console.info({ id: this.linhaSelecionada });
        this.$refs.deletarLinha.show();
      }
    },
    selecionaSetor(record) {
      this.setorSelecionado = record ? record[0].id : null;
      this.descricaoSetorSelecionado = record ? record[0].descricao : null;
    },
    async vincularSetor() {
      this.$refs.addSetor.hide();

      if (this.setorSelecionado != null) {
        await axios
          .put(
            `${config.default.servidor}/gerencial/vinculo-interesse`,
            {
              empresaid: localStorage.getItem("enterprise_id"),
              tipoid: 1,
              interesseid: this.id,
              codigovinculado: this.setorSelecionado,
              descricaovinculado: this.descricaoSetorSelecionado
            },
            {
              headers: {
                Authorization: "Basic c2E6QURNQUNDRVNZUw=="
              }
            }
          )
          .then(async resp => {
            if (resp.status == 200) {
              this.isLoading = true;
              this.setorSelecionado = null;
              this.descricaoSetorSelecionado = null;
              const options = { title: "Sucesso!", size: "sm" };
              this.$dialogs.alert("O setor foi vinculado com sucesso", options);
              await this.receberVinculos();
              this.isLoading = false;
            }
          });
      } else {
        const options = { title: "Algo deu errado...", size: "sm" };
        await this.$dialogs
          .alert("Selecione um setor para ser vinculado!", options)
          .then(res => {
            this.$refs.addSetor.show();
          });
      }
    },
    selecionaGrupo(record) {
      this.grupoSelecionado = record ? record[0].id : null;
      this.descricaoGrupoSelecionado = record ? record[0].descricao : null;
    },
    async vincularGrupo() {
      this.$refs.addGrupo.hide();

      if (this.grupoSelecionado != null) {
        await axios
          .put(
            `${config.default.servidor}/gerencial/vinculo-interesse`,
            {
              empresaid: localStorage.getItem("enterprise_id"),
              tipoid: 2,
              interesseid: this.id,
              codigovinculado: this.grupoSelecionado,
              descricaovinculado: this.descricaoGrupoSelecionado
            },
            {
              headers: {
                Authorization: "Basic c2E6QURNQUNDRVNZUw=="
              }
            }
          )
          .then(async resp => {
            if (resp.status == 200) {
              this.isLoading = true;
              this.grupoSelecionado = null;
              this.descricaoGrupoSelecionado = null;
              const options = { title: "Sucesso!", size: "sm" };
              this.$dialogs.alert("O grupo foi vinculado com sucesso", options);
              await this.receberVinculos();
              this.isLoading = false;
            } else if (resp.status == 201) {
              const options = { title: "Aviso", size: "sm" };
              this.$dialogs.alert("Grupo já vinculado", options);
            }
          });
      } else {
        const options = { title: "Algo deu errado...", size: "sm" };
        await this.$dialogs
          .alert("Selecione um grupo para ser vinculado!", options)
          .then(res => {
            this.$refs.addGrupo.show();
          });
      }
    },
    async openModal(id) {
      if (id == 1) {
        this.isLoading = true;
        await this.receberSetores();
        this.isLoading = false;
        this.$refs.addSetor.show();
      } else {
        this.isLoading = true;
        await this.receberGrupos();
        this.isLoading = false;
        this.$refs.addGrupo.show();
      }
    },
    onFilteredSetor(filteredItems) {
      this.totalRowsSetor = filteredItems.length;
      this.currentPageSetor = 1;
    },
    onFilteredGrupo(filteredItems) {
      this.totalRowsGrupo = filteredItems.length;
      this.currentPageGrupo = 1;
    },
    onChange(image) {
      if (image) {
        this.saveBtn = true;
        localStorage.setItem("image", image);
      } else {
        this.saveBtn = false;
      }
    },
    goBack() {
      localStorage.removeItem("desc_interesse");
      localStorage.removeItem("img_interesse");
      this.$router.go(-1);
    },
    save() {
      axios
        .post(
          `${config.default.servidor}/gerencial/vincular-imagem-interesse`,
          {
            idempresa: localStorage.getItem("enterprise_id").toString(),
            idinteresse: this.id,
            imagem: localStorage.getItem("image")
          },
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            let toast = this.$toasted.show("Sucesso!", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "check",
              iconPack: "fontawesome"
            });
          } else {
            let toast = this.$toasted.show("Algo deu errado.", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "times",
              iconPack: "fontawesome"
            });
          }
          this.goBack();
        })
        .catch(error => {
          let toast = this.$toasted.show("Algo deu errado.", {
            theme: "toasted-primary",
            position: "bottom-center",
            duration: 5000,
            icon: "times",
            iconPack: "fontawesome"
          });
        });
    },
    async receberSetores() {
      await axios
        .get(
          `${config.default.servidor}/gerencial/setores/${localStorage.getItem(
            "enterprise_id"
          )}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            this.setores = response.data.data;
          }
        });
      this.totalRowsSetor = this.setores.length;
    },
    async receberVinculos() {
      await axios
        .get(
          `${
            config.default.servidor
          }/gerencial/vinculo-interesse/${localStorage.getItem(
            "enterprise_id"
          )}/${this.id}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            this.vinculos = response.data.data;
          }
        });
      this.totalRowsSetor = this.setores.length;
    },
    async receberGrupos() {
      await axios
        .get(
          `${config.default.servidor}/gerencial/grupos/${localStorage.getItem(
            "enterprise_id"
          )}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            this.grupos = response.data.data;
          }
        });
      this.totalRowsGrupo = this.grupos.length;
    }
  },
  async beforeMount() {
    this.isLoading = true;
    this.id = this.$route.params.id;
    this.descricao = localStorage.getItem("desc_interesse");
    this.imageSource = localStorage.getItem("img_interesse");
    await this.receberVinculos();
    this.isLoading = false;
  }
};
</script>
